import { Component, signal, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { TellentMember } from '@core/tellent-types';
import {
  ButtonComponent,
  ButtonLoadingDirective,
  DialogBodyComponent,
  DialogComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
} from '@core/user-interface-legacy';

import { MemberBoxComponent } from '../member-box/member-box.component';

type AddEmployeesToListDialogData = { members: TellentMember[] };

type AddEmployeesToListDialogResult = { confirmed: boolean };

@Component({
  selector: 'tla-add-employees-to-list-dialog',
  imports: [
    DialogHeaderComponent,
    DialogBodyComponent,
    TranslatePipe,
    ButtonComponent,
    ButtonLoadingDirective,
    DialogFooterComponent,
    MemberBoxComponent,
  ],
  templateUrl: './add-employees-to-list-dialog.component.html',
  styleUrl: './add-employees-to-list-dialog.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [],
})
export class AddEmployeesToListDialog extends DialogComponent<
  AddEmployeesToListDialogData,
  AddEmployeesToListDialogResult
> {
  protected membersData = signal<TellentMember[]>([]);
  protected isLoading = signal(false);

  public setDialogData(data: AddEmployeesToListDialogData, _triggerUpdate: boolean): void {
    this.membersData.set(data.members);
  }

  public proceed(): void {
    this.isLoading.set(true);
    this.dialogRef.close({ confirmed: true });
  }

  protected cancel(): void {
    this.dialogRef.close(undefined);
  }
}
